import React, { useState, useRef, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// styles
import { WrapEnroll, extendStylesEnrollForm, TableHeaderEnroll, TableContentEnroll } from './index.styles'
// component
import FormSubmitControl from '../Control/FormSubmitControl'
import PageHeader from '../Control/PageHeader'
import EmptyDataControl from '../Control/EmptyDataControl'
import HistoryItem from './HistoryItem'
import Input from '../../../../Control/Input'
import DragAndDropImage from '../../../../Control/DragAndDropImage'
import Button from '../../../../Control/Button'

//image
import IcInputUser from '../../../../../assets/images/IcInputUser'
import IcInputUserActive from '../../../../../assets/images/IcInputUserActive'
import IcInputUserError from '../../../../../assets/images/IcInputUserError'
import IcBtnRegister from '../../../../../assets/images/IcBtnRegister'

// action
import { enrollNewUser } from '../../../../../redux/enrol/action'
import { getFilterUser, resetFilterUser } from '../../../../../redux/enrol/filterUser/action'
import { getCountUser } from '../../../../../redux/enrol/action';

// helper
import fileToBase64 from '../../../../../helper/fileToBase64'
import * as tools from '../../../../../helper/tools'

//data
import { errorInput } from '../../../../../data/errorInput'

const dataHeader = [
    "#",
    "Faceprint",
    "CIF Number",
    "Processing Time",
    "Requested Date",
    "Time"
]

const iconUser = {
    icon: IcInputUser,
    iconActive: IcInputUserActive,
    iconError: IcInputUserError,
}

const Enroll = () => {
    const dispatch = useDispatch()
    const listRef = useRef(null)

    const [listData, setListData] = useState([])
    const [valueCIF, setValueCIF] = useState("")
    // const [checkForm, seCheckForm] = useState(true)
    const [isDisabledBtnRegister, setIsDisabledBtnRegister] = useState(true);
    const [faceImg, setFaceImg] = useState(null);

    const { filterUserReducer } = useSelector(state => ({
        filterUserReducer: state.filterUserReducer
    }))

    useEffect(() => {
        dispatch(getFilterUser({ filterFrom: '', filterSkip: 0, filterSize: -1 }))
        dispatch(getCountUser())
        return () => {
            
        }
    }, [])

    useEffect(() => {
        const isEnable = valueCIF.length === 11 && !!faceImg
        setIsDisabledBtnRegister(!isEnable)
    }, [faceImg, valueCIF]);

    useEffect(() => {
        if(!filterUserReducer?.userList) return
        let list = filterUserReducer.userList
        
        for (let i = 0; i < filterUserReducer.userList.length; i++) {
            let item = filterUserReducer.userList[i];
            let index = filterUserReducer.userList.length - i
            item.index = tools.formatStringID(index, 6);
        }
        if(list) setListData(list)
        return () => {
            
        }
    }, [JSON.stringify(filterUserReducer)])


    const _handleValidateInput = (value,callback) =>{
        if (!value.trim() || 0 === value.length) {
            callback(errorInput.errorEmpty)
            return
        }
        if (value.indexOf(' ') >= 0) {
            callback(errorInput.errorSpace)
            return
        }
        const validChar = /[0-9]+/g
        const invalidChars = value.replace(validChar, "")
        if(invalidChars) {
            callback(errorInput.errorChar)
            return
        }
        if(value.length < 11){
            callback(errorInput.errorLength)
            return
        }
    }

    const callbackSuccess = () => {
        
    }

    const callbackFinal = () => {
        const callbackResetFilterSuccess = () => {
            dispatch(getFilterUser({ filterFrom: '', filterSkip: 0, filterSize: -1 }))
        }
        dispatch(resetFilterUser(callbackResetFilterSuccess))
        dispatch(getCountUser())
        setFaceImg(null)
        setValueCIF("")
    }

    const  _handleSubmitForm = async () =>{
        // console.log(valueCIF)
        const base64 = await fileToBase64(faceImg)
        const dataRequest = { 
            cif: valueCIF, 
            photo: base64.split(',')[1]
        }
        dispatch(enrollNewUser(dataRequest, callbackSuccess, null, callbackFinal))
    }

    const _handlePressCif = (e) => {
        if(e.key === 'Enter' && !isDisabledBtnRegister) {
            _handleSubmitForm()
        }
    }

    const tableContent = useMemo(() => (
        listData.length === 0 ?
        <div className="wrap-empty">
            <EmptyDataControl />
        </div>
        :
        <div className="wrap-list-trans" ref={listRef}>
            <div className="list-trans">
                {
                    listData.map((item, i) => (
                        <HistoryItem key={i} className='history-item'
                            item={item} />
                    ))
                }
            </div>
        </div>
    ), [JSON.stringify(listData)])

    return (
        <WrapEnroll>
            <PageHeader>Enrollment Information</PageHeader>
            <FormSubmitControl extendStyles={extendStylesEnrollForm}>
                <div className="wrap-content">
                    <div className="left-content">
                        <p className="form-title">Face Picture</p>
                        <DragAndDropImage 
                            file={faceImg}
                            handleRemoveFile={() => setFaceImg(null)}
                            handleDropFiles={files => setFaceImg(files[0])}
                        />
                    </div>
                    <div className="right-content">
                        <p className="form-title">CIF Number</p>
                        <Input 
                            placeholder="CIF Number"
                            inputType="TEXT"
                            value={valueCIF}
                            required
                            onChange={(e) => setValueCIF(e.target.value)}
                            onKeyPress={_handlePressCif}
                            iconInput={iconUser}
                            handleValidationInput={_handleValidateInput}
                            className="input-enroll"
                            maxLength="11"
                        />
                        <Button 
                            text="Register"
                            iconBtn={<IcBtnRegister />}
                            className="btn-submit"
                            isDisable={isDisabledBtnRegister}
                            onClick={_handleSubmitForm}
                        />
                    </div>
                </div>
            </FormSubmitControl>
            <PageHeader>Search History</PageHeader>
            <TableHeaderEnroll>
                {
                    dataHeader.map((item, i) => (
                        <div className="table-header" key={i}>
                            {item}
                        </div>
                    ))
                }
            </TableHeaderEnroll>
            <TableContentEnroll>
                {tableContent}
            </TableContentEnroll>
        </WrapEnroll>
    )
}

export default Enroll
